module.exports = __webpack_public_path__ + "img/logo_big.f6a00227.png";